import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Sparkles, X } from 'lucide-react';
import AskEnfernoChat from './AskEnfernoChat';
import { useAuth } from '../context/AuthContext';
import { useFeatureFlag } from '../context/FeatureFlagsContext';

const HIDE_ON = ['/login', '/register', '/onboarding', '/coach'];

/**
 * Always-on floating "Ask Enferno" button + slide-up drawer.
 * Hidden on auth flows, onboarding, and the dedicated /coach page (since the
 * chat is already the page there).
 */
const FloatingCoach = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const { user } = useAuth();
  const { enabled: coachEnabled } = useFeatureFlag('ai_coach');

  if (HIDE_ON.includes(pathname)) return null;
  if (!user) return null;  // Only signed-in users get the coach
  if (!coachEnabled) return null;  // Staged-launch flag: hidden until reveal day

  return (
    <>
      {/* Trigger button — fixed bottom-right */}
      <button
        onClick={() => setOpen(true)}
        className="fixed bottom-5 right-5 z-40 group flex items-center gap-2 pl-3 pr-4 py-2.5 bg-enf-accent hover:bg-enf-accent-hover rounded-full shadow-lg shadow-enf-accent/30 border border-enf-accent-fg/60 transition-all hover:shadow-enf-accent/50 hover:scale-105"
        data-testid="floating-coach-trigger"
        aria-label="Open Ask Enferno chat"
      >
        <Sparkles className="w-4 h-4 text-enf-text-primary group-hover:rotate-12 transition-transform" />
        <span className="text-xs font-semibold uppercase tracking-widest text-enf-text-primary">Ask Enferno</span>
      </button>

      {/* Drawer */}
      {open && (
        <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center p-0 sm:p-4 bg-black/70 backdrop-blur-sm" onClick={() => setOpen(false)}>
          <div onClick={(e) => e.stopPropagation()}
            className="w-full sm:max-w-2xl enferno-drawer-rise"
            data-testid="floating-coach-drawer"
          >
            <div className="relative">
              <button
                onClick={() => setOpen(false)}
                className="absolute -top-2 -right-2 sm:-top-3 sm:-right-3 z-10 w-9 h-9 rounded-full bg-enf-surface-mid hover:bg-enf-accent border border-enf-surface-border flex items-center justify-center transition-colors"
                aria-label="Close chat"
                data-testid="floating-coach-close"
              >
                <X className="w-4 h-4" />
              </button>
              <AskEnfernoChat variant="drawer" />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default FloatingCoach;
